module.exports = __webpack_public_path__ + "img/high-you-icon3.aa9802da.png";